/**
 * Determines the direction of the scroll effect behind the text.
 * If `Vertical`, the background will appear to scroll from top to bottom. If `Horizontal`, the
 * background will appear move from left to right.
 */
export enum ScrollEffectDirection {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}
